/**
 * Resolves the T2 (Tier 2) ancestor title for a risk in the hierarchy.
 *
 * Returns the risk's own title if it is already Tier 2. Otherwise walks up
 * the ParentRiskId chain until a Tier 2 ancestor is found. Returns null for
 * Tier 1 risks (no T2 ancestor exists), orphans (chain breaks before
 * reaching a T2), and cycles (max-depth guard).
 */
export const getT2CategoryTitle = (
  risk: {
    Id: string;
    Tier: number;
    Title: string;
    ParentRiskId?: string | null;
  },
  riskById: Map<
    string,
    { Id: string; Tier: number; Title: string; ParentRiskId?: string | null }
  >
): string | null => {
  if (risk.Tier === 2) {
    return risk.Title;
  }
  let current: typeof risk | undefined = risk;
  let depth = 0;
  while (current?.ParentRiskId && depth < 10) {
    current = riskById.get(current.ParentRiskId);
    if (current?.Tier === 2) {
      return current.Title;
    }
    depth++;
  }

  return null;
};
